import { ApplicationPolicy } from '@/policies/ApplicationPolicy'

export abstract class UserPolicy extends ApplicationPolicy {
  public static manageUsers() {
    return this.hasUserManagementAccess()
  }

  public static viewSpeakers() {
    return this.hasSpeakersAccess()
  }

  public static viewDocuments() {
    return this.hasBoothsAccess()
  }

  public static viewEvents() {
    return this.hasEventsAccess()
  }

  public static viewContentPages() {
    return this.hasContentPagesAccess()
  }

  public static viewTickets() {
    return this.hasTicketsAccess()
  }

  public static viewCompany() {
    return this.hasCompanyProfileAccess()
  }

  public static viewProspectCatalog() {
    return this.hasLeadGenerationRole()
  }

  public static viewLeads() {
    return this.hasMyLeadsAccess()
  }

  public static viewRecruitingPlus() {
    return this.hasRecruitingPlusAccess()
  }

  public static viewVisitorProfiles() {
    return this.hasVisitorProfilesAccess()
  }

  public static viewFestivalShop() {
    return this.hasFestivalShopAccess()
  }

  public static viewMeetings() {
    return this.hasMeetingsAccess()
  }
}

export enum UserAbilities {
  manageUsers = 'manageUsers',
}
